import config from 'appConfig';
let history = {};

if (config && !config.isApp) {
  // const createBrowserHistory = require('history').createBrowserHistory;
  history = config.history;
}
// configure, create, and export the project's history instance
export default history;
